import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Prefer css/sx wherever possible
export const useIsSmallScreen: () => boolean = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));

// Prefer css/sx wherever possible
export const useIsMediumScreen: () => boolean = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
